import { SET_RENEWAL_DATA } from "./types";
import { addMonths } from "date-fns";
/**
 * Create initial state for KYC Renewal reducer
 */
export function createInitialState(initialEndDateMonths = 12) {
    const now = new Date();
    return {
        renewalStartDate: addMonths(now, -6),
        renewalEndDate: addMonths(now, initialEndDateMonths),
        disable_confirm_modal: true,
        distributerList: [],
        isdashboardLoading: false,
        showConfirmPopup: true,
        popupBtnDisable: false,
        EnvSiteName: process.env.SITE_ADDRESS || "",
        defaultStartDate: addMonths(now, -6),
        multiSelectedDistributersKey: [],
        resetBtn: true,
        // Customer Renewals Analysis state
        isCustomerRenewalsLoading: false,
        customerRenewalsData: null,
        customerRenewalsError: null,
        customerRenewalsUsePrimarySite: false,
    };
}
/**
 * KYC Renewal reducer factory
 * Creates a reducer with a specific initial end date offset
 */
export function createKYCRenewalReducer(initialEndDateMonths = 12) {
    const initialState = createInitialState(initialEndDateMonths);
    return function kycRenewalReducer(state = initialState, action) {
        switch (action.type) {
            case SET_RENEWAL_DATA:
                return { ...state, ...action.payload };
            default:
                return state;
        }
    };
}
/**
 * Default KYC Renewal reducer (uses 12 months for admin-portal compatibility)
 */
export default createKYCRenewalReducer(12);
